import MetricUp from './MetricUp';

export default MetricUp;